import React, { useState } from "react";
import styled from "styled-components";


const PlaceOrderSuccess = () => {
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);

  const handlePlaceOrder = () => {
    setIsOrderPlaced(true);
    setTimeout(() => {
      setIsOrderPlaced(false); // Reset after showing the animation
    }, 3000); // Animation duration
  };

  return (
    <Wrapper>
    <div className="place-order-container">
      {!isOrderPlaced ? (
        <button onClick={handlePlaceOrder} className="place-order-button">
          Place Order
        </button>
      ) : (
        <div className="success-message">
          <div className="success-icon">
                <span>&#10004;</span>
          </div>
          <p>Order Placed Successfully!</p>
        </div>
      )}
    </div>
    </Wrapper>
  );
};
 const Wrapper = styled.section`
 .place-order-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f9f9f9;
  font-family: Arial, sans-serif;
}

.place-order-button {
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #4caf50;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.place-order-button:hover {
  background-color: #45a049;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e8f5e9;
  padding: 20px;
  border: 2px solid #4caf50;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  animation: fadeInScale 0.5s ease-in-out;
}

.success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4caf50;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  margin-bottom: 10px;
  animation: bounce 0.5s ease-in-out;
}

.success-message p {
  font-size: 18px;
  color: #4caf50;
  margin: 0;
}

/* Animations */
@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
`
export default PlaceOrderSuccess;
